import axios from "axios";
import { config } from "./config";

const api = axios.create({
  baseURL: config.api.baseUrl,
  headers: { "Content-Type": "application/json" },
});

// Public endpoints
export async function listPosts() {
  const res = await api.get("/posts");
  return res.data;
}

export async function getPost(slug) {
  const res = await api.get(`/posts/${slug}`);
  return res.data;
}

// Authenticated endpoints
export async function createPost(post, token) {
  const res = await api.post("/posts", post, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function updatePost(slug, post, token) {
  const res = await api.put(`/posts/${slug}`, post, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function deletePost(slug, token) {
  const res = await api.delete(`/posts/${slug}`, {
    headers: { Authorization: token },
  });
  return res.data;
}

// User management (authenticated)
export async function listUsers(token) {
  const res = await api.get("/users", {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function addUser(email, token) {
  const res = await api.post("/users", { email }, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function removeUser(username, token) {
  const res = await api.delete(`/users/${encodeURIComponent(username)}`, {
    headers: { Authorization: token },
  });
  return res.data;
}
